module.exports = __webpack_public_path__ + "img/text_icon.1b17259d.png";